export default __webpack_public_path__ + "static/media/serviceprovider.f5cdaa07.png";